import { combineEpics } from 'redux-observable';

import addRequestEventEpic from './addRequestEvent.epic';
import fetGuestRequestsEpic from './fetchGuestRequests.epic';

export default combineEpics(fetGuestRequestsEpic, addRequestEventEpic);
